/** Formatação em pt-BR, moeda BRL, fuso da loja. */

let storeTimezone = 'America/Bahia';

export function setStoreTimezone(tz: string): void {
  storeTimezone = tz;
}
export function getStoreTimezone(): string {
  return storeTimezone;
}

export function formatBRL(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '—';
  const negative = cents < 0;
  const abs = Math.abs(cents);
  const inteiro = Math.trunc(abs / 100).toLocaleString('pt-BR');
  const centavos = String(abs % 100).padStart(2, '0');
  return `${negative ? '-' : ''}R$ ${inteiro},${centavos}`;
}

/** Converte "199,90" ou "199.90" em centavos, sem float. */
export function parseCentsInput(value: string): number | null {
  const raw = value.trim().replace(/\s|R\$/g, '');
  if (raw.length === 0) return null;
  const normalized = raw.includes(',') ? raw.replace(/\./g, '').replace(',', '.') : raw;
  if (!/^-?\d+(\.\d{1,2})?$/.test(normalized)) return null;
  const negative = normalized.startsWith('-');
  const [int = '0', frac = ''] = (negative ? normalized.slice(1) : normalized).split('.');
  const cents = Number(int) * 100 + Number(frac.padEnd(2, '0') || '0');
  return negative ? -cents : cents;
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: storeTimezone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
    .format(date)
    .replace(',', ' às');
}

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '—';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-');
    return `${d}/${m}/${y}`;
  }
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: storeTimezone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: storeTimezone,
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

/** Data de hoje no fuso da loja, em 'YYYY-MM-DD'. */
export function todayLocal(): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: storeTimezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
  return parts;
}

export function formatPhone(e164: string | null | undefined): string {
  if (!e164) return '—';
  const match = /^\+55(\d{2})(\d{4,5})(\d{4})$/.exec(e164);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : e164;
}

export function formatQuantity(value: string | null | undefined): string {
  if (!value) return '—';
  return value.replace(/0+$/, '').replace(/\.$/, '').replace('.', ',');
}

export function vehicleLabel(v: {
  make?: string | null;
  model?: string | null;
  model_year?: number | null;
  plate?: string | null;
}): string {
  const base = [v.make, v.model, v.model_year].filter(Boolean).join(' ');
  if (v.plate) return base ? `${base} — ${v.plate}` : v.plate;
  return base || 'Veículo sem identificação';
}
